import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { AuctionUWMap, AuctionUWGrid, AuctionUWBuyBoxCriterias } from '../auctionUnderwrite';
import ErrorBoundary from 'components/hoc/ErrorBoundary';
import {
  appNotify, setAuctionUWMapState
} from 'store/actions';
import {
  selectedAuctionTxnOppsSelector
} from 'store/selectors';
import { AuctionUWHeader } from '../auctionUnderwrite';
import {
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import Resizable from 're-resizable';
// import SubText from 'components/SubText';
// import SubTextDivider from 'components/SubTextDivider';
import { MapWrapper } from 'components/map';
import debounce from 'lodash/debounce';

const styles = theme => ({
  root: {
    display: 'grid',
    // height: 'calc(100vh - 48px)',
    // gridTemplateColumns: '1fr 50px',
    gridTemplateColumns: '1fr',
    gridTemplateRows: '80px 1fr',
    // gridTemplateAreas: `
    // 'header header'
    // 'content contentNav'
    // `
    gridTemplateAreas: `
    'header'
    'content'
    `
  },
  content: {
    gridArea: 'content',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // fontSize: '2rem',
    overflowY: 'auto',
    //display: 'grid',
    // gridTemplateAreas: `
    //   'summary'
    //   'portfolio'
    //   'map'`,
    // gridTemplateRows: 'min-content min-content',
    // marginTop: theme.spacing(0.5)
    padding: '8px'
  },
  contentNav: {
    gridArea: 'contentNav',
    paddingTop: theme.spacing(1)
  },
  contentNavDivider: {
    margin: theme.spacing(1)
  },
  header: {
    gridArea: 'header'
    //padding: '10px',
  },
  subHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  summary: {
    gridArea: 'summary',
    display: 'flex',
    // alignItems: 'center',
    justifyContent: 'center'
  },
  auctionSummary: {
    width: '50%',
    display: 'flex',
    //height: '100%',
    flexDirection: 'column'
    //padding: '10px'
  },
  portfolio: {
    gridArea: 'portfolio',
    display: 'flex',
    flexFlow: 'column',
  },
  buyBoxContainer: {
    overflowY: 'hidden',
    overflowX: 'auto'
    // width: '50%',
    //padding: '10px',
    //height: '100%',
    // minHeight: '100px',
  },
  map: {
    gridArea: 'map',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    flexGrow: '1',
    //padding: '10px',
    minHeight: '400px'
    //maxHeight: '500px',
  },
  mapCard: {
    padding: '0!important',
    borderRadius: 8,
    overflow: 'hidden',
    // minHeight: '700px',
    flexGrow: 1,
    margin: 8
  },
  container: {
    display: 'grid',
    // gridTemplateAreas: `
    // 'header proforma'
    // 'nav proforma'
    // 'content proforma'
    // `,
    // gridTemplateRows: '80px 30px 1fr',
    gridTemplateAreas: `'content proforma'`,
    gridTemplateColumns: '1fr auto'
  },
  // grid: {
  //   width: '100%',
  //   height: '100%',
  //   marginBottom: '1rem',
  //   overflowY: 'auto',
  // },
  contentHeader: {
    borderBottom: '1px solid black',
    marginBottom: '5px'
  },
  loadingText: {
    color: theme.palette.primary.contrastText
  }
});


// const scrollToElement = element => {
//   if (document.getElementById(element)) {
//     document.getElementById(element).scrollIntoView({ behavior: 'smooth' });
//   }
// };

const AuctionUWContent = ({
  classes,
  selectedAuctionTxnOpps,
  selectedAuctionICBMStrategies,
  user,
  auctionUWMapState,
  zoom,
  center,
  gestureHandling,
  mapViewType,

  setAuctionUWMapState,
  appNotify,

  selectedTask,
  isUserOwnedTask
}) => {
  const onZoomChanged = debounce((map) => {
    setAuctionUWMapState({ zoom: map.getZoom() });        // we store the zoom so that when we navigate away and navigate back, that we can set it back to the original zoom
  }, 900);
  const onCenterChanged = debounce((map) => {
    const getCenterFunc = map.getCenter();
    setAuctionUWMapState({ center: { lat: getCenterFunc.lat(), lng: getCenterFunc.lng() } });
  }, 900);

  const errorBoundaryFallback = (errorInfo) => {
    return (
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='subtitle2'>Something went wrong.</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant='body2'>
            {errorInfo?.error && errorInfo.error.toString()}
          </Typography>
        </AccordionDetails>
      </Accordion>
    )
  }

  return (
    selectedAuctionTxnOpps && selectedTask
      ? <div className={classes.root}>
        <div className={classes.header}>
          <AuctionUWHeader selectedTask={selectedTask} selectedAuctionTxnOpps={selectedAuctionTxnOpps} isUserOwnedTask={isUserOwnedTask} />
        </div>
        <div className={classes.content} id="auctionUWContentContainer">
          <div style={{ display: 'flex', minHeight: 380, flexGrow: 1, flexBasis: '50%' }}>
            <div id="auctionUWSummarySection" style={{ margin: 8, width: '50%', maxWidth: 800 }}>
              <Typography variant='h6' style={{ marginTop: -8, fontSize: '1rem' }}>Buy Box Criteria Summary</Typography>
              <AuctionUWBuyBoxCriterias
                selectedTask={selectedTask}
                selectedAuctionTxnOpps={selectedAuctionTxnOpps}
                selectedAuctionICBMStrategies={selectedAuctionICBMStrategies}
              />
              {/* </ContentCard> */}
            </div>
            <div id="auctionUWMapSection" className={classes.mapCard}>
              <ErrorBoundary fallbackRender={errorBoundaryFallback}>
                {selectedAuctionTxnOpps && (
                  <MapWrapper
                    zoom={zoom}
                    center={center}
                    mapViewType={mapViewType}
                    onZoomChanged={onZoomChanged}
                    onCenterChanged={onCenterChanged}
                    gestureHandling={gestureHandling}
                  >
                    <AuctionUWMap />
                  </MapWrapper>
                )}
              </ErrorBoundary>
            </div>
          </div>
          <Divider style={{ margin: 8 }} />
          <div style={{ display: 'flex', minHeight: 360, flexGrow: 1, flexBasis: '50%' }}>
            <div id="auctionUWGridSection" style={{ width: '100%', padding: 8 }}>
              <Typography variant='h6' style={{ marginTop: -8, marginBottom: 8, fontSize: '1rem' }}>Transaction Opportunities</Typography>
              <AuctionUWGrid
                isUserOwnedTask={isUserOwnedTask}
                selectedTask={selectedTask}
                user={user}
              />
            </div>
          </div>
        </div>
      </div>
      : <div>No auction portfolio for that ID</div>
  );
};

const mapStateToProps = state => {
  return {
    selectedAuctionTxnOpps: selectedAuctionTxnOppsSelector(state),
    selectedAuctionICBMStrategies: state.auctionUWState.selectedAuctionICBMStrategies,
    user: state.appState.user,
    auctionUWMapState: state.auctionUWState.auctionUWMapState,
    zoom: state.auctionUWState.auctionUWMapState.zoom,
    center: state.auctionUWState.auctionUWMapState.center,
    gestureHandling: state.auctionUWState.auctionUWMapState.gestureHandling,
    mapViewType: state.auctionUWState.auctionUWMapState.mapViewType
  }
};
const mapDispatchToProps = dispatch => ({
  setAuctionUWMapState: auctionUWMapState => dispatch(setAuctionUWMapState(auctionUWMapState)),
  appNotify: (message, variant, options) => dispatch(appNotify(message, variant, options)),
});
export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AuctionUWContent);
